export default [{
  path: '/order/all/list',
  component: resolve => require(['./list.vue'], resolve)
}, {
  path: '/order/detail',
  component: resolve => require(['./detail.vue'], resolve)
}, {
  path: '/order/:service/:RuleType/:UniqueID',
  component: resolve => require(['./BackToChange/BackToChange.vue'], resolve)
}, {
  path: '/mall/:service/ChangeInfos',
  component: resolve => require(['./BackToChange/ChangeInfos.vue'], resolve)
}, {
  path: '/mall/hotel/map',
  component: resolve => require(['../mall/hotel/map.vue'], resolve)
}]



// WEBPACK FOOTER //
// ./src/views/order/router.js